module.exports = __webpack_public_path__ + "IM.png?f912b7ac7d50279016506ee21ff920d4";